const Strengths = () => {
  const strengths = [
    {
      title: 'World\'s Smallest Gun Drilling',
      description: 'φ0.5mm deep hole drilling capability',
      image: 'https://www.hi-tak.co.jp/wp-content/uploads/2021/01/DSCF1412_sonota.png'
    },
    {
      title: 'Ultra-Thin Wall Deep Hole Drilling',
      description: 'Breaking conventional drilling limitations',
      image: 'https://www.hi-tak.co.jp/wp-content/uploads/2021/01/semi4_img.png'
    },
    {
      title: 'High-Precision Multi-Hole Drilling',
      description: 'Small diameter multi-hole processing',
      image: 'https://www.hi-tak.co.jp/wp-content/uploads/2021/01/DSCF1404_iryo.png'
    },
    {
      title: 'Advanced Development Capability',
      description: 'Expertise from gun drill machine design',
      image: 'https://www.hi-tak.co.jp/wp-content/uploads/2021/01/DSCF1373-scaled.jpg'
    },
    {
      title: 'Long Workpiece Processing',
      description: 'Up to 3000mm deep hole drilling',
      image: 'https://www.hi-tak.co.jp/wp-content/uploads/2017/01/tech_reason.jpg'
    },
    {
      title: 'New Honing Machine Development',
      description: 'Latest precision finishing technology',
      image: 'https://www.hi-tak.co.jp/wp-content/uploads/2021/01/Untitled-17.png'
    },
    {
      title: 'Extensive Tool Variety',
      description: 'Wide range of gun drills and machines',
      image: 'https://www.hi-tak.co.jp/wp-content/uploads/2017/01/kougu01.jpg'
    },
    {
      title: 'Medical Device Manufacturing',
      description: 'Registered medical device manufacturer',
      image: 'https://www.hi-tak.co.jp/wp-content/uploads/2021/01/piron-guillaume-U4FyCp3-KzY-unsplash-scaled.jpg'
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-[#002A4E] to-[#001E3C] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `repeating-linear-gradient(45deg, #00D9C9 0, #00D9C9 1px, transparent 0, transparent 50%)`,
          backgroundSize: '20px 20px'
        }}></div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#00D9C9] text-sm font-semibold tracking-wider uppercase">Our Advantages</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mt-4 mb-6">
            Why Choose HI-TAK
          </h2>
          <p className="text-xl text-white/70 max-w-3xl mx-auto">
            Eight core strengths that make us the industry leader in precision deep hole drilling
          </p>
        </div>

        {/* Strengths Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {strengths.map((strength, index) => (
            <div
              key={index}
              className="group relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg overflow-hidden hover:bg-white/10 hover:border-[#00D9C9]/50 transition-all duration-500"
            >
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <div className="w-full h-full">
                  <img
                    src={strength.image}
                    alt={strength.title}
                    className="w-full h-full object-cover object-top transform group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-[#001E3C] via-[#001E3C]/70 to-transparent"></div>
                
                {/* Number Badge */}
                <div className="absolute top-4 right-4">
                  <div className="w-10 h-10 bg-[#00D9C9] rounded-full flex items-center justify-center">
                    <span className="text-[#001E3C] font-bold text-lg">{index + 1}</span>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-lg font-bold text-white mb-2 group-hover:text-[#00D9C9] transition-colors duration-300">
                  {strength.title}
                </h3>
                <p className="text-white/70 text-sm leading-relaxed">
                  {strength.description}
                </p>
              </div>

              {/* Hover Effect */}
              <div className="absolute bottom-0 left-0 w-0 h-1 bg-[#00D9C9] group-hover:w-full transition-all duration-500"></div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a
            href="#contact"
            className="group inline-flex items-center gap-2 text-[#00D9C9] font-semibold hover:gap-4 transition-all duration-300 whitespace-nowrap"
          >
            Learn More About Our Capabilities
            <i className="ri-arrow-right-line text-xl w-6 h-6 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Strengths;
